import React, { useState, useEffect, useRef, useContext } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";
import moment from "moment";
import axios from "axios";

import Card from "@material-ui/core/Card";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";

import AuthContext from "../../../../context/auth-context";
import RenameRulePieceDialog from "./RenameRulePieceDialog";
import DeleteRulePieceDialog from "./DeleteRulePieceDialog";
import CopyRulePieceDialog from "./CopyRulePieceDialog";
import RulePieceHistory from "./RulePieceHistory";

import brSvg from "../../../../assets/br.svg";
import usSvg from "../../../../assets/us.svg";

function RulePieceCard(props) {
    let { rule_piece, setSnackBarStatus, handleUpdate } = props;

    const roles = useContext(AuthContext).user_data.roles;

    const user_language = useContext(AuthContext).user_data.locale;

    const { t } = useTranslation();

    const optionsRef = useRef(null);
    const [disableAll, setDisableAll] = useState(false);
    const [rulePieceOptionsOpen, setRulePieceOptionsOpen] = useState(false);
    const [openDeleteRuleDialog, setOpenDeleteRuleDialog] = useState(false);
    const [renameRuleDialogOpen, setRenameRuleDialogOpen] = useState(false);
    const [copyRuleDialogOpen, setCopyRuleDialogOpen] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const handleExpand = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };

    const handleCopy = () => {
        if (disableAll) return;
        setDisableAll(true);
        axios
            .post("/dash/rule_engine/rule_piece/" + rule_piece.rule_piece_key + '/copy', {})
            .then((response) => {
                handleRequestFinish("success", "Trecho copiado com sucesso");
            })
            .catch((error) => {
                if ((error.response || {}).status === 409)
                    handleRequestFinish(
                        "error",
                        "Não é possível copiar este trecho!"
                    );
                else
                    handleRequestFinish("error", "Não foi possível copiar esse trecho!");
            });
    };


    const handleExclude = () => {
        if (disableAll) return;
        setDisableAll(true);
        axios
            .delete("/dash/rule_engine/rule_piece/" + rule_piece.rule_piece_key)
            .then((response) => {
                handleRequestFinish("success", "Trecho excluído com sucesso");
            })
            .catch((error) => {
                if ((error.response || {}).status === 409)
                    handleRequestFinish(
                        "error",
                        "Não é possível excluir uma trecho ativo!"
                    );
                else
                    handleRequestFinish("error", "Não foi possível excluir esse trecho!");
            });
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (optionsRef.current && !optionsRef.current.contains(event.target)) {
                setRulePieceOptionsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [optionsRef]);

    const handleRenameDialogOpen = () => {
        setRenameRuleDialogOpen(true);
    };

    const handleRenameDialogClose = () => {
        setRenameRuleDialogOpen(false);
    };

    const handleCopyDialogClose = () => {
        setCopyRuleDialogOpen(false);
    };

    const handleRequestFinish = (severity, message) => {
        setSnackBarStatus({
            opened: true,
            severity: severity,
            message: message,
        });
        handleUpdate();
        setDisableAll(false);
    };

    let gridTemplateColumns = "30% 27% 27% 11% 5%"
    if (roles.includes("multiple_environment_viewer")) {
        gridTemplateColumns = "25% 27% 27% 5% 11% 5%"
    }

    return (
        <div style={{ marginBottom: "5px" }}>
            <Card className="listCard">
                <div
                    style={{ display: "flex", flexDirection: "column", width: "100%" }}
                >
                    <div style={{ display: "grid", gridTemplateColumns: gridTemplateColumns }}>
                        <Link
                            className={[
                                "listCardItem",
                                "link",
                                "normalMediumSize",
                                "breakWord",
                                "bold",
                            ].join(" ")}
                            style={{ textAlign: "center" }}
                            to={"/rule-piece/" + rule_piece.rule_piece_key + "/" + rule_piece.version}
                        >
                            {rule_piece.name ? t(rule_piece.name) : "-"}
                        </Link>
                        <div
                            className={[
                                "listCardItem",
                                "normalText",
                                "normalMediumSize",
                                "noWrap",
                            ].join(" ")}
                            style={{ textAlign: "center" }}
                        >
                            {!rule_piece.version_date ? " - " :
                                user_language === "en"
                                    ? moment(rule_piece.version_date).format("MM/DD/YYYY HH:mm:ss")
                                    : moment(rule_piece.version_date).format("DD/MM/YYYY HH:mm:ss")}
                        </div>
                        <div
                            className={[
                                "listCardItem",
                                "normalText",
                                "normalMediumSize",
                                "noWrap",
                            ].join(" ")}
                            style={{ textAlign: "center" }}
                        >
                            {!rule_piece.created_at ? " - " :
                                user_language === "en"
                                    ? moment(rule_piece.created_at).format("MM/DD/YYYY HH:mm:ss")
                                    : moment(rule_piece.created_at).format("DD/MM/YYYY HH:mm:ss")}
                        </div>

                        {roles.includes("multiple_environment_viewer") &&
                            <div
                                className={[
                                    "listCardItem",
                                    "normalText",
                                    "subtitleSize",
                                    "noWrap",
                                ].join(" ")}
                                style={{ textAlign: "center" }}
                            >
                                {(rule_piece.region === "sa_east_1")
                                    ?
                                    <Tooltip title={
                                        <p className="tooltipText" style={{ textAlign: "center" }}>
                                            {t("Hospedado em ambiente Brasil")}
                                        </p>}>
                                        <img src={brSvg} alt="Brazil Flag" width="30" height="30" />
                                    </Tooltip>
                                    :
                                    <Tooltip title={
                                        <p className="tooltipText" style={{ textAlign: "center" }}>
                                            {t("Hospedado em ambiente Estados Unidos")}
                                        </p>}>
                                        <img src={usSvg} alt="US Flag" width="30" height="30" />
                                    </Tooltip>
                                }
                            </div>
                        }
                        <div
                            className={[
                                "listCardItem",
                                "normalText",
                                "subtitleSize",
                                "noWrap",
                            ].join(" ")}
                            style={{ textAlign: "center" }}
                        >
                            <MoreHorizIcon
                                style={{ verticalAlign: "middle", cursor: "pointer" }}
                                onClick={() => setRulePieceOptionsOpen(!rulePieceOptionsOpen)}
                            />
                        </div>
                        <div
                            className={[
                                "listCardItem",
                                "normalText",
                                "subtitleSize",
                                "noWrap",
                            ].join(" ")}
                            style={{ textAlign: "center" }}
                        >
                            <IconButton onClick={handleExpand}>
                                {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                            </IconButton>
                        </div>
                    </div>
                    <Collapse
                        in={expanded}
                        timeout="auto"
                        unmountOnExit
                        style={{ margin: "10px" }}
                    >
                        <div
                            style={{
                                paddingTop: "30px",
                            }}
                        >
                            <div className={["blueText", "normalMediumSize"].join(" ")}>
                                {t("Histórico de Versões")}
                            </div>

                            <RulePieceHistory rule_piece={rule_piece} />
                        </div>
                    </Collapse>
                </div>

                {rulePieceOptionsOpen ? (
                    <div className="listCardPlusContainerReduced2" ref={optionsRef}>
                        <div
                            className={[
                                "normalText",
                                "normalMediumSize",
                                "listCardPlusOptions2",
                            ].join(" ")}
                            onClick={handleRenameDialogOpen}
                        >
                            <span style={{ margin: "auto" }}>{t("Renomear Trecho")}</span>
                        </div>
                        {
                            (roles.includes('rule_piece_creator') || roles.includes('rule_piece_editor')) &&
                            <div
                                className={[
                                    "normalText",
                                    "normalMediumSize",
                                    "listCardPlusOptions2",
                                ].join(" ")}
                                onClick={() => setOpenDeleteRuleDialog(true)}
                            >
                                <span style={{ margin: "auto" }}>{t("Desativar Trecho")}</span>
                            </div>
                        }
                        {
                            (roles.includes('rule_piece_creator') || roles.includes('rule_piece_editor')) &&
                            <div
                                className={[
                                    "normalText",
                                    "normalMediumSize",
                                    "listCardPlusOptions2",
                                ].join(" ")}
                                onClick={() => setCopyRuleDialogOpen(true)}
                            >
                                <span style={{ margin: "auto" }}>{t("Copiar Trecho")}</span>
                            </div>
                        }
                        {
                            (roles.includes('rule_piece_creator') || roles.includes('rule_piece_editor')) &&
                            <div
                                className={[
                                    "normalText",
                                    "normalMediumSize",
                                    "listCardPlusOptions2",
                                ].join(" ")}
                                style={{ textAlign: 'center' }}
                                onClick={() => setOpenDeleteRuleDialog(true)}
                            >
                                <Link
                                    className={[
                                        "linkNoStyle",
                                        "normalText",
                                        "normalMediumSize",
                                        "listCardPlusOptions2"
                                    ].join(" ")}
                                    style={{ display: "inline-block" }}
                                    to={"/rule-piece/" + rule_piece.rule_piece_key + '/events'}
                                >
                                    <span>{t("Alterar Eventos")}</span>
                                </Link>
                            </div>
                        }
                    </div>
                ) : null}
                <CopyRulePieceDialog open={copyRuleDialogOpen} onClose={handleCopyDialogClose} onConfirm={handleCopy} />
                <DeleteRulePieceDialog open={openDeleteRuleDialog} onClose={() => setOpenDeleteRuleDialog(false)} onConfirm={handleExclude} />
                <RenameRulePieceDialog
                    open={renameRuleDialogOpen}
                    onClose={handleRenameDialogClose}
                    handleRequestFinish={handleRequestFinish}
                    rule_piece={rule_piece}
                />
            </Card>
        </div>
    )
}

export default RulePieceCard